import { SessionShell, SessionHeader } from '../../../ui';
import { useSessionState } from '../../../context/sessionStateContext';
import { buildMenuItems, useConfirmExitSession } from '../hooks';
import { ScreenSizeGuard } from '../ScreenSizeGuard';

// Header + shell for the desktop patient's non-test screens (patient-view.js): waiting (P2/P4/P7),
// card / ruler / camera calibration and distance (P3.2-P6). Same header title and read-only menu
// as the tablet / phone container (ResponsivePatientContainer).

const CALIBRATION_TABS = ['screen-calibration', 'camera-calibration', 'ruler', 'card'];

export const patientHeaderTitle = (tab, step) => {
  if (CALIBRATION_TABS.includes(tab)) return tab === 'camera-calibration' ? 'Camera Calibration' : 'Calibration Selection';
  if (tab === 'pupillaryDistance' || tab === 'blindspot') return 'Set Distance';
  if (step === 'set-distance') return 'Set Distance';
  if (!step || step === 'calibration-selection') return 'Calibration Selection';
  if (step === 'results') return 'Completed Examinations';
  return 'Examinations';
};

const patientMenuStep = (tab, step) => {
  if (CALIBRATION_TABS.includes(tab)) return 'calibration-selection';
  if (tab === 'pupillaryDistance' || tab === 'blindspot') return 'set-distance';
  if (['calibration-selection', 'set-distance', 'results'].includes(step)) return step;
  return step ? 'test' : 'calibration-selection';
};

export const PatientSessionShell = ({ activeTab, children }) => {
  const { state } = useSessionState();
  const exitSession = useConfirmExitSession();
  const step = state?.step;
  return (
    <ScreenSizeGuard>
      <SessionShell
        fixed
        header={
          <SessionHeader
            title={patientHeaderTitle(activeTab, step)}
            menuItems={buildMenuItems({ activeTab: patientMenuStep(activeTab, step), readOnly: true, onEnd: exitSession, endLabel: 'Exit Session' })}
          />
        }
      >
        {children}
      </SessionShell>
    </ScreenSizeGuard>
  );
};

export default PatientSessionShell;
